import { useDeviceStore, useMenuStore, useScrollDirection } from 'hooks';
import { globalStorage } from 'services/globalStorage';

import { useHandleRef } from '../useHandleRef/useHandleRef';
import { useMenuInit } from '../useMenuInit/useMenuInit';

export const useMenuWrapperCombiner = () => {
  const store = useMenuStore();
  const { isOnBoarding, isNotFound } = globalStorage;
  const { deviceLimitExceeded, householdList } = useDeviceStore();
  const isHouseHold = deviceLimitExceeded && householdList.length !== 0;
  const handleRef = useHandleRef();

  useScrollDirection();

  useMenuInit();

  return {
    store,
    isNotFound,
    isOnBoarding,
    isHouseHold,
    handleRef,
  };
};
